import { getText } from './i18n';

type LocalizeOptions = {
  locale?: string;
};

const normalizeToken = (value: string) =>
  value
    .trim()
    .replace(/^Reject[_\s-]+/i, '')
    .replace(/\bVolumn\b/gi, 'Volume')
    .replace(/[%]/g, ' percent ')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/gi, '')
    .toLowerCase();

const RESULT_LABEL_KEYS: Record<string, string> = {
  serial: 'resultLabelSerial',
  image: 'resultLabelImage',
  imagepath: 'resultLabelImage',
  length: 'grainLength',
  avglength: 'grainLength',
  stdlength: 'grainLength',
  width: 'grainWidth',
  avgwidth: 'grainWidth',
  stdwidth: 'grainWidth',
  areabase: 'grainArea',
  area: 'grainArea',
  areamm2: 'grainArea',
  avgareabase: 'grainArea',
  stdareabase: 'grainArea',
  aspectratio: 'grainAspectRatio',
  avgaspectratio: 'grainAspectRatio',
  stdaspectratio: 'grainAspectRatio',
  headricelength: 'resultLabelHeadRiceLength',
  avglengthofbrokengrains: 'resultLabelHeadRiceLength',
  volume: 'resultLabelVolume',
  volumn: 'resultLabelVolume',
  rmean: 'resultLabelRedMean',
  gmean: 'resultLabelGreenMean',
  bmean: 'resultLabelBlueMean',
  lmean: 'resultLabelLMean',
  amean: 'resultLabelAMean',
  bmeanlab: 'resultLabelBMean',
  isbroken: 'resultLabelBroken',
  broken: 'resultLabelBroken',
  brokenaandbgrain: 'resultLabelBrokenAAndB',
  bigbroken: 'resultLabelBigBroken',
  bigbrokenagrains: 'resultLabelBigBroken',
  smallbroken: 'resultLabelSmallBroken',
  smallbrokenbgrains: 'resultLabelSmallBroken',
  foreignmatter: 'resultLabelForeignMatter',
  foreignmaterial: 'resultLabelForeignMatter',
  fm: 'resultLabelForeignMatter',
  fm1: 'resultLabelForeignMatterStone',
  fm2: 'resultLabelForeignMatterOther',
  foreignmaterialstone: 'resultLabelForeignMatterStone',
  foreignmaterialother: 'resultLabelForeignMatterOther',
  foreignmatterother: 'resultLabelForeignMatterOther',
  chalky: 'resultLabelChalky',
  chalkydamage: 'resultLabelChalky',
  chalkyrawsela: 'resultLabelChalkyRawSela',
  discolored: 'resultLabelDiscoloredGrain',
  discolor: 'resultLabelDiscoloredGrain',
  discoloredgrain: 'resultLabelDiscoloredGrain',
  damaged: 'resultLabelDamagedGrain',
  damage: 'resultLabelDamagedGrain',
  damagedgrain: 'resultLabelDamagedGrain',
  redandredstreaked: 'resultLabelRedAndRedStreaked',
  redgrain: 'resultLabelRedGrain',
  green: 'resultLabelGreenDamage',
  greendamage: 'resultLabelGreenDamage',
  greengrain: 'resultLabelGreenGrain',
  greenpaddy: 'resultLabelGreenPaddy',
  immature: 'resultLabelImmatureGrains',
  immaturegrain: 'resultLabelImmatureGrains',
  immaturegrains: 'resultLabelImmatureGrains',
  immatureshrivelled: 'resultLabelImmatureShrivelled',
  immaturesmall: 'resultLabelImmatureSmall',
  admixture: 'resultLabelAdmixtureGrains',
  admix: 'resultLabelAdmixtureGrains',
  admixturegrains: 'resultLabelAdmixtureGrains',
  pindamage: 'resultLabelPinDamage',
  redline: 'resultLabelRedline',
  frk: 'resultLabelFRK',
  na: 'resultLabelNA',
  weeviled: 'resultLabelWeeviled',
  weevileddamage: 'resultLabelWeeviled',
  weeviledamage: 'resultLabelWeeviled',
  fungus: 'resultLabelFungusDamage',
  fungusdamage: 'resultLabelFungusDamage',
  waterdamage: 'resultLabelWaterDamage',
  khanda: 'resultLabelKhanda',
  chochlatey: 'resultLabelChochlatey',
  chocolatey: 'resultLabelChochlatey',
  blackdamage: 'resultLabelBlackDamage',
  blackbeans: 'resultLabelBlackBeans',
  blacktipgrain: 'resultLabelBlackTipGrain',
  combinedrice: 'resultLabelCombinedRice',
  deadpaddy: 'resultLabelDeadPaddy',
  field: 'resultLabelField',
  value: 'resultLabelValue',
  heatdamage: 'resultLabelHeatDamage',
  insecteatenbeans: 'resultLabelInsectEatenBeans',
  jeeraunmilledbig: 'resultLabelJeeraUnmilledBig',
  karnalbuntgrain: 'resultLabelKarnalBuntGrain',
  otherfoodgrains: 'resultLabelOtherFoodGrains',
  parchments: 'resultLabelParchments',
  potiagrain: 'resultLabelPotiaGrain',
  purpledamage: 'resultLabelPurpleDamage',
  quakerbeans: 'resultLabelQuakerBeans',
  sampleweight: 'sampleWeight',
  samplenumber: 'sampleNumber',
  brandname: 'brandName',
  moisture: 'moisture',
  trucknumber: 'truckNumber',
  pricepertonne: 'pricePerTonne',
  lotsize: 'lotSize',
  numberofbags: 'numberOfBags',
  acceptedbags: 'acceptedBags',
  rejectedbags: 'rejectedBags',
  sellername: 'sellerName',
  selleraadharnumber: 'sellerAadharNumber',
  sellerphonenumber: 'sellerPhoneNumber',
  surveyorname: 'surveyorName',
  surveyorid: 'surveyorId',
  surveyorphonenumber: 'surveyorPhoneNumber',
  shellbeans: 'resultLabelShellBeans',
  shriveldamage: 'resultLabelShrivelDamage',
  shriveleddamage: 'resultLabelShrivelDamage',
  shrivelledbeans: 'resultLabelShrivelledBeans',
  splitdal: 'resultLabelSplitDal',
  sourbeans: 'resultLabelSourBeans',
  floaterbeans: 'resultLabelFloaterBeans',
  twigs: 'resultLabelTwigs',
  unmilledjeeramedium: 'resultLabelUnmilledJeeraMedium',
  unmilledjeerasmall: 'resultLabelUnmilledJeeraSmall',
  goodgrains: 'goodGrains',
  goodgrainpercent: 'goodGrains',
  rejectedgrains: 'rejectedGrains',
  rejectiongrains: 'rejectedGrains',
  rejectionpercent: 'rejectedGrains',
  graincount: 'totalKernels',
  totalkernels: 'totalKernels',
  whitenessindex: 'whitenessIndex',
  type: 'resultLabelType',
  name: 'resultLabelName',
  count: 'resultLabelCount',
  percentbycount: 'resultLabelPercentByCount',
  bycount: 'resultLabelPercentByCount',
  percentbyweight: 'resultLabelPercentByWeight',
  byweight: 'resultLabelPercentByWeight',
  acceptablepercentwt: 'resultLabelAcceptableWeight',
  acceptablewt: 'resultLabelAcceptableWeight',
  average: 'resultLabelAverage',
  avg: 'resultLabelAverage',
  sd: 'resultLabelSD',
  standarddeviation: 'resultLabelSD',
  lowerbound: 'resultLabelLowerBound',
  upperbound: 'resultLabelUpperBound',
  rangename: 'resultLabelName',
  percentage: 'resultLabelPercentByCount',
  percentagebyweight: 'resultLabelPercentByWeight',
  particlesingroup: 'resultLabelCount',
  totalweight: 'resultLabelTotalWeight',
};

const EXACT_RESULT_LABEL_KEYS: Record<string, string> = {
  B_Mean: 'resultLabelBlueMean',
  b_Mean: 'resultLabelBMean',
};

export const normalizeResultLabel = (rawLabel: unknown): string | undefined => {
  if (rawLabel === null || rawLabel === undefined) return undefined;

  const label = String(rawLabel).trim();
  if (!label) return undefined;
  if (EXACT_RESULT_LABEL_KEYS[label]) return EXACT_RESULT_LABEL_KEYS[label];

  const rangeMatch = label.match(/^Range\s+(\d+)$/i);
  if (rangeMatch) return `range:${rangeMatch[1]}`;

  return RESULT_LABEL_KEYS[normalizeToken(label)];
};

const translateKey = (key: string, fallback: string, params: Record<string, string> = {}) => {
  const translated = getText(key, params);
  if (!translated || translated === key || translated.includes('[missing')) {
    return fallback;
  }
  return translated;
};

export const localizeResultLabel = (rawLabel: unknown, _options: LocalizeOptions = {}) => {
  if (rawLabel === null || rawLabel === undefined) return '';

  const label = String(rawLabel);
  const key = normalizeResultLabel(label);
  if (!key) return label;

  if (key.startsWith('range:')) {
    return translateKey('resultLabelRange', label, { number: key.split(':')[1] });
  }

  return translateKey(key, label);
};

export const localizeResultCell = (rawValue: unknown, options: LocalizeOptions = {}) => {
  if (rawValue === null || rawValue === undefined) return '';

  const value = String(rawValue);
  return normalizeResultLabel(value) ? localizeResultLabel(value, options) : value;
};
